import { createFileRoute } from "@tanstack/react-router";
import { LabTestsPage } from "@/modules/lab-tests/presentation/pages/LabTestsPage";

export const Route = createFileRoute("/_authenticated/lab-tests")({
  component: LabTestsPage,
});
